import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';


@Injectable({ providedIn: 'root' })
export class ClinicMedServicesEmployeeIdsService extends ApiService {
  endPoint = '/api/clinicmedserviceemployee/getemployeeids';
  
  get(id: string): Observable<any> {
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  
}
